import { z } from 'zod';

import { learningPathStatusSchema } from './learningPathApi.schema';
import { stageKeySchema } from './stage.schema';

export { learningPathStatusSchema };

export type LearningPathStatus = z.infer<typeof learningPathStatusSchema>;

// The student listing adds CONCLUIDA: every stage of the path was submitted by the student.
export const studentLearningPathStatusSchema = z.enum(['PROGRAMADA', 'PRODUCAO', 'CONCLUIDA', 'ENCERRADA']);

export type StudentLearningPathStatus = z.infer<typeof studentLearningPathStatusSchema>;

export const learningPathOrderingSchema = z.enum([
  'MAIS_RECENTES',
  'MAIS_ANTIGAS',
  'PRAZO_MAIS_PROXIMO',
  'PRAZO_MAIS_DISTANTE',
]);

export type LearningPathOrdering = z.infer<typeof learningPathOrderingSchema>;

// The listing stage shape is kept independent from the create/edit payload. Dates may be '' while
// the form preview is being filled in, hence plain strings.
export const learningPathsListStageSchema = z.object({
  etapa: stageKeySchema,
  dataHoraInicio: z.string(),
  dataHoraEncerramento: z.string(),
});

const listParamsBaseSchema = z.object({
  anoLetivo: z.number().int().optional(),
  busca: z.string().optional(),
  ordenacao: learningPathOrderingSchema.optional(),
  page: z.number().int().nonnegative().optional(),
  size: z.number().int().positive().optional(),
});

export const getLearningPathsParamsSchema = listParamsBaseSchema.extend({
  escolaId: z.number().int().optional(),
  status: learningPathStatusSchema.optional(),
});

export type GetLearningPathsParams = z.infer<typeof getLearningPathsParamsSchema>;

export const getStudentLearningPathsParamsSchema = listParamsBaseSchema.extend({
  status: studentLearningPathStatusSchema.optional(),
});

export type GetStudentLearningPathsParams = z.infer<typeof getStudentLearningPathsParamsSchema>;

export const learningPathsListItemSchema = z.object({
  id: z.number().int(),
  tituloTema: z.string(),
  imagemUrl: z.string().nullable(),
  generoTextual: z.string().nullable(),
  qtdTurmas: z.number().int(),
  qtdAlunos: z.number().int(),
  // Optional because the form preview builds an item before the path exists.
  status: studentLearningPathStatusSchema.optional(),
  etapas: z.array(learningPathsListStageSchema),
});

export type LearningPathsListItem = z.infer<typeof learningPathsListItemSchema>;

export const learningPathsPageableSchema = z.object({
  pageNumber: z.number().int(),
  pageSize: z.number().int(),
  totalElements: z.number().int(),
  sort: z.string().optional(),
});

// Red1000Response envelope with Red1000Pageable: { data, pageable }.
export const learningPathsListResponseSchema = z.object({
  data: z.array(learningPathsListItemSchema),
  pageable: learningPathsPageableSchema,
});

export type LearningPathsListResponse = z.infer<typeof learningPathsListResponseSchema>;
